import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'sync-link-error',
    templateUrl: './link-error.component.html'
})
export class LinkErrorComponent implements OnInit {

    public key: string;
    @Output() linkkey = new EventEmitter<string>();

    @Input() errcode;
    constructor() { }

    ngOnInit() {
        console.log('sync link error = ', this.errcode);
    }

    public setKey() {
        this.linkkey.emit(this.key);
    }
}
